import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetFormAsset } from '../../hooks/useGetFormAsset';
import { Preloader } from '../Preloader';
import Heading from '../../../../generic-components/Heading';
import Button from '../../../../generic-components/Button';
import { ReactComponent as PrintIcon } from '../../../../assets/tax-forms/form-print.svg';
import { ReactComponent as PdfIcon } from '../../../../assets/tax-forms/form-pdf.svg';
import { NAVBAR_TITLE_MAP, STYLES } from '../../consts';
import { trackMixPanel } from '../../../../services/mixpanel.service';
import { useStore } from '../../../../store';
import { getFormNumber } from '../../utils';

const {
  PREVIEW: {
    TOP_BAR_CONTAINER, TOP_BAR_ACTIONS_CONTAINER, TOP_BAR_HEADER, IFRAME_CONTAINER, IFRAME, WRAPPER,
  },
} = STYLES;

interface IProps {
    formId: string;
}
export const FormPreviewWrapper = ({ formId }: IProps) => {
  const elIframe = useRef<HTMLIFrameElement>(null);
  const { formType } = useParams();
  const { t } = useTranslation();
  const {
    isLoading, isRefetching, data: assetUrl, refetch,
  } = useGetFormAsset({ formId });
  const routerHistory = useStore(state => state.routerHistory);

  const handlePrintPdf = () => {
    if (elIframe?.current?.contentWindow) {
      trackMixPanel(`Act on form ${getFormNumber(formType)}`, { Action: 'export' });
      elIframe.current.contentWindow.print();
    }
  };
  const handleShowPdf = () => {
    trackMixPanel(`Act on form ${getFormNumber(formType)}`, { Action: 'export' });
    window.open(assetUrl, '_blank');
  };

  useEffect(() => {
    refetch();
  }, [formId]);

  useEffect(() => {
    const originRoute = routerHistory[routerHistory.length - 2];
    const isFromInnerFlow = originRoute && originRoute.includes('tax-forms');
    trackMixPanel(`View form ${getFormNumber(formType)} screen`, { Origin: isFromInnerFlow ? `View form ${getFormNumber(formType)} Success Screen` : 'Accounting reports' });
    refetch();
  }, []);

  return (isLoading || isRefetching) ? <Preloader /> : (
    <div className={WRAPPER}>
      <div className={TOP_BAR_CONTAINER}>
        <Heading title={t(NAVBAR_TITLE_MAP[formType as keyof typeof NAVBAR_TITLE_MAP])} className={TOP_BAR_HEADER} />
        <div className={TOP_BAR_ACTIONS_CONTAINER}>
          <Button onClick={handlePrintPdf} className='' id='printForm' childElement={<PrintIcon />} />
          <Button onClick={handleShowPdf} className='' id='showPdf' childElement={<PdfIcon />} />
        </div>
      </div>
      <div className={IFRAME_CONTAINER}>
        <iframe ref={elIframe} className={IFRAME} src={assetUrl} title='Form preview' />
      </div>
    </div>
  );
};
